import type { GuideId } from './guides';
import { ExternalLink } from 'lucide-react';
import { cn } from 'helpers/cn';
import { GUIDES } from './guides';

type GuideLinkProps = {
  guide: GuideId;
  /** The visible text; the guide's own title when absent. */
  label?: string;
  className?: string;
};

/**
 * A link to a public guide on pertento.ai, in a new tab. A short label keeps the full title as
 * its tooltip. The icon is joined to the last word by a no-break space, so a title that wraps
 * keeps its icon on the last line instead of leaving it at the end of the first.
 */
export const GuideLink = ({ guide, label, className }: GuideLinkProps) => {
  const { title, href } = GUIDES[guide];

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={label ? title : undefined}
      className={cn('text-accent hover:text-foreground transition-colors duration-150', className)}
    >
      {label ?? title}
      {' '}
      <ExternalLink aria-hidden="true" className="inline size-3 align-[-1px]" strokeWidth={1.75} />
    </a>
  );
};
